export default __webpack_public_path__ + "static/media/img_snmpget-colorBkg.72c335f8.png";